import { useTranslation } from 'react-i18next';
import type { Languages } from '@ki-components/frontend-common';

export const GetLanguages = (): Languages[] => {
  const { t } = useTranslation();
  return [
    { code: 'de-DE', name: t('languages.german') },
    { code: 'en-GB', name: t('languages.english') }
  ];
};
